import * as UI from "@iyk/ui"
import * as React from "react"

import { setThemeTo } from "../../ui/themes.ts"

export const SectionLayout = React.forwardRef<HTMLDivElement, SectionLayoutProps>(
  ({ children, className, size, theme, ...props }, ref) => {
    return (
      <section ref={ref} className={classForSectionLayout({ size, className, theme })} {...props}>
        {children}
      </section>
    )
  },
)

// 100rem = 1600px
const classForSectionLayout = UI.cva(["mx-auto"], {
  variants: {
    size: {
      fluid: "w-full",
      container: "max-w-[100rem]",
    },
    theme: {
      dark: setThemeTo("dark"),
      light: setThemeTo("light"),
    },
  },
})

export type SectionLayoutProps = UI.HTMLElementProps<
  Required<UI.VariantProps<typeof classForSectionLayout>>
>
